export default __webpack_public_path__ + "static/CIC-1c1c60f9fd4fccec9628f7cc0ba6398b.svg";